import React from 'react';

import Cloud from './Cloud';
import './style.scss';

const CloudsBackground = ({ children }) => {
  const clouds = [
    { size: 'large', type: 'move', style: { top: '1%', left: '130%' } },
    { size: 'medium', type: 'move', style: { top: '40%', left: '50%' } },
    { size: 'medium', type: 'move', style: { top: '85%', left: '2%' } },
    { size: 'large', type: 'move', style: { top: '130%', right: '-5%' } },
    { size: 'large', type: 'move', style: { top: '160%', left: '-36%' } },
    { size: 'small', type: 'move', style: { top: '190%', right: '13%' } },
    { size: 'medium', type: 'move', style: { top: '240%', left: '92%' } },
    { size: 'medium', type: 'move', style: { top: '290%', right: '72%' } },
  ];

  return (
    <div className="clouds-background">
      {clouds.map((cloud, index) => (
        <Cloud key={index} {...cloud} />
      ))}
      <div className="content">{children}</div>
    </div>
  );
};

export default CloudsBackground;
